import { INITIALIZE_GENERATION_ACCURACY } from '../actionTypes';
import { actions } from '../reducer';

export default (values) => actions[INITIALIZE_GENERATION_ACCURACY](values);
